import { Layout, Menu, Tooltip } from 'antd';
import Logo from '../../../../components/logo/logo';
import {
  AudioOutlined,
  ClockCircleOutlined,
  CustomerServiceOutlined,
  FontSizeOutlined,
  GlobalOutlined,
  InfoCircleOutlined,
  MessageOutlined,
  OrderedListOutlined,
  PictureOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons';
import React, { FunctionComponent } from 'react';
import { TITLE_BY_VIDEO_PAGE, VideoPart } from '../../video-editor-types';
import { useVideoContext } from '../../../../hooks/use-video';
import Changelog, {
  CHANGELOG_KEY,
} from '../../../../components/changelog/changelog';
import { useStore } from '../../../../helpers/use-store';
import { useTranslation } from 'react-i18next';

const VideoSidebar: FunctionComponent = () => {
  const { t } = useTranslation();
  const {
    dataStore: { userStore },
  } = useStore();
  const { currentVideoPart, setCurrentVideoPart } = useVideoContext();

  let actualSelected: VideoPart = currentVideoPart;

  if (
    currentVideoPart === VideoPart.EditScene ||
    currentVideoPart === VideoPart.EditSceneItem
  ) {
    actualSelected = VideoPart.Scenes;
  }

  return (
    <Layout.Sider width={90}>
      <div className="logo">
        <Logo />
      </div>
      <Menu
        selectedKeys={[actualSelected]}
        mode="inline"
        defaultSelectedKeys={[VideoPart.Scenes]}
        onClick={(item) => {
          if (item.key === 'help') {
            window.Featurebase('show');
            return;
          }

          setCurrentVideoPart(item.key as VideoPart);
        }}
        items={[
          {
            key: VideoPart.Global,
            label: (
              <Tooltip
                placement={'right'}
                title={t('videoEditor.sidebar.globalScene')}
              >
                <div>
                  <GlobalOutlined />
                </div>
              </Tooltip>
            ),
          },
          {
            key: VideoPart.Thumbnail,
            label: (
              <Tooltip
                placement={'right'}
                title={t('videoEditor.sidebar.thumbnail')}
              >
                <div>
                  <PictureOutlined />
                </div>
              </Tooltip>
            ),
          },
          {
            key: VideoPart.Scenes,
            label: (
              <Tooltip
                placement={'right'}
                title={t('videoEditor.sidebar.scenes')}
              >
                <div>
                  <OrderedListOutlined />
                </div>
              </Tooltip>
            ),
          },
          {
            key: VideoPart.Captions,
            label: (
              <Tooltip
                placement={'right'}
                title={t('videoEditor.sidebar.captions')}
              >
                <div>
                  <MessageOutlined />
                </div>
              </Tooltip>
            ),
          },
          {
            key: VideoPart.Subtitles,
            label: (
              <Tooltip
                placement={'right'}
                title={t('videoEditor.sidebar.captionsStyle')}
              >
                <div>
                  <FontSizeOutlined />
                </div>
              </Tooltip>
            ),
          },
          {
            key: VideoPart.Voiceover,
            label: (
              <Tooltip
                placement={'right'}
                title={t('videoEditor.sidebar.voiceover')}
              >
                <div>
                  <AudioOutlined />
                </div>
              </Tooltip>
            ),
          },
          // {
          //   key: VideoPart.Effects,
          //   label: 'Effects',
          //   icon: <StarOutlined />,
          // },
          // {
          //   key: VideoPart.Music,
          //   label: (
          //     <Tooltip placement={'right'} title={`Music`}>
          //       <div>
          //         <CustomerServiceOutlined />
          //       </div>
          //     </Tooltip>
          //   ),
          // },
          {
            key: VideoPart.Metadata,
            label: (
              <Tooltip
                placement={'right'}
                title={t('videoEditor.sidebar.metadata')}
              >
                <div>
                  <InfoCircleOutlined />
                </div>
              </Tooltip>
            ),
          },
          {
            key: VideoPart.Jobs,
            label: (
              <Tooltip
                placement={'right'}
                title={t('videoEditor.sidebar.aiJobs')}
              >
                <div>
                  <ClockCircleOutlined />
                </div>
              </Tooltip>
            ),
          },
          {
            key: 'help',
            label: (
              <Tooltip
                placement={'right'}
                title={t('videoEditor.sidebar.help')}
              >
                <div>
                  <QuestionCircleOutlined />
                </div>
              </Tooltip>
            ),
          },
        ]}
      />
    </Layout.Sider>
  );
};

export default VideoSidebar;
